<template>
  <div
    class="exclusives"
    data-test="exclusives">
    <div class="container">
      <Loader
        v-if="loading"
        :center="true"
      />
      <h2
        class="title"
      >
        Luminary Exclusives
      </h2>

      <el-row
        v-if="!loading"
        :gutter="16"
        data-test="columns"
      >
        <el-col
          v-for="exclusivePodcast in podcasts"
          :key="exclusivePodcast.uuid"
          :md="8"
          :sm="12"
          :xs="12"
          class="exclusive-column"
          data-test="exclusive-column"
        >
          <ExclusiveCard
            :podcast="exclusivePodcast"
          />
        </el-col>
      </el-row>

      <el-row
        type="flex"
        justify="center"
        class="container"
      >
        <el-pagination
          v-if="!loading && totalPodcasts > limit"
          :page-size="limit"
          :total="totalPodcasts"
          :current-page="currentPage"
          layout="prev, pager, next"
          @current-change="loadNewPage"
        />
      </el-row>
    </div>
  </div>
</template>

<script>
import Podcast from '../services/Podcast';
import ExclusiveCard from '../components/ExclusiveCard';
import Loader from '../components/Loader';
import PageMixin from '../shared/pageMixin';

export default {
  components: {
    ExclusiveCard,
    Loader,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Luminary Exclusives',
      podcastService: new Podcast(),
      podcasts: [],
      loading: false,
      currentPage: 1,
      limit: 18,
      totalPodcasts: 0,
    };
  },
  mounted() {
    this.getExclusivePodcasts();
  },
  methods: {
    loadNewPage(newPage) {
      this.currentPage = newPage;
      this.getExclusivePodcasts();
    },
    getExclusivePodcasts() {
      this.loading = true;

      const params = {
        p: this.currentPage,
        limit: this.limit,
        imagetype: 'featured',
      };

      this.podcastService.getExclusivePodcasts(params)
        .then((response) => {
          this.loading = false;
          this.podcasts = response.podcasts;
          this.totalPodcasts = response.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.exclusives {
  margin-bottom: 30px;

  .title {
    font-size: 32px;
    margin: 40px 0 45px;

    @media (max-width: 567px) {
      font-size: 18px;

      margin: 30px 0 25px;
    }
  }

  .exclusive-column {
    margin-bottom: 32px;

    @media (max-width: 1024px) {
      width: 50%;

      margin-bottom: 16px;
    }

    @media (max-width: 567px) {
      width: 100%;

      margin-bottom: 16px;
    }
  }

  .el-pagination {
    margin: 48px 0 25px;

    .btn-prev .el-icon, .btn-next .el-icon{
      font-size: 24px;
      color: $light-gray2;
    }
    .btn-prev {
      padding-right: 0px;
    }
    .btn-next {
      padding-left: 0px;
    }
    .el-pager {
      margin: 0 40px;
    }
    .el-pager li {
      min-width: auto;
      margin-right: 32px;
    }
    .el-pager li.number {
      font-size: 16px;
      color: $black;
      min-width: 8px;
    }
    .el-pager li.number:last-child {
      margin-right: 0px;
    }
    .el-pager li.number.active {
      font-size: 16px;
      color: $blue;
    }
  }
}

</style>



// WEBPACK FOOTER //
// app/src/pages/Exclusives.vue